import { Box, Typography, Paper } from '@mui/material';
import { CategorySectionProps } from './types';
import { RuleBuilder } from '../../../InstrumentIdentifiers/components/RuleBuilder/RuleBuilder';
import './CategorySection.scss';

export const CategorySection = (props: CategorySectionProps) => {
  const { category, sectionId, templateId, instrumentType, availableHeaders } =
    props;

  return (
    <Paper className="categorySection" variant="outlined">
      <Box className="categorySectionHeader">
        <Typography variant="h6" className="categorySectionTitle">
          {category.title}
        </Typography>
      </Box>

      <Box className="categorySectionContent">
        <RuleBuilder
          categoryId={category.id}
          sectionId={sectionId}
          templateId={templateId}
          instrumentType={instrumentType}
          availableHeaders={availableHeaders}
        />
      </Box>
    </Paper>
  );
};
